import pimg1 from '../images/project/1.webp'
import pimg2 from '../images/project/2.webp'
import pimg3 from '../images/project/3.webp'
import pimg4 from '../images/project/4.webp'
import pimg5 from '../images/project/2.webp'




const Projects = [
    {
        id: '1',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '1',
        pimg1: pimg1,
        date: 'Feb 2024',
        location: 'Austria',
        type: 'Investment planning',
        service: 'It, Company',
        duration: '12 Years',
        add: 'Millington, Ave, TN 38053',
        architect: 'Don Johnson',
        share: 'It, Company',
        fax: ' 568 746 987'
    },
    {
        id: '2',
        title: 'Product Design',
        subtitle: 'Product / Idea',
        slug: '2',
        pimg1: pimg2,
        date: 'Feb 2024',
        location: 'Austria',
        type: 'Investment planning',
        service: 'It, Company',
        duration: '12 Years',
        add: 'Millington, Ave, TN 38053',
        architect: 'Don Johnson',
        share: 'It, Company',
        fax: ' 568 746 987'
    },
    {
        id: '3',
        title: 'Web Development',
        subtitle: 'Web / Design',
        slug: '3',
        pimg1: pimg3,
        date: 'Feb 2024',
        location: 'Austria',
        type: 'Investment planning',
        service: 'It, Company',
        duration: '12 Years',
        add: 'Millington, Ave, TN 38053',
        architect: 'Don Johnson',
        share: 'It, Company',
        fax: ' 568 746 987'
    },
    {
        id: '4',
        title: 'eCommerce Project',
        subtitle: 'Design / Idea',
        slug: '4',
        pimg1: pimg4,
        date: 'Feb 2024',
        location: 'Austria',
        type: 'Investment planning',
        service: 'It, Company',
        duration: '12 Years',
        add: 'Millington, Ave, TN 38053',
        architect: 'Don Johnson',
        share: 'It, Company',
        fax: ' 568 746 987'
    },
    {
        id: '5',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '5',
        pimg1: pimg5,
        date: 'Feb 2024',
        location: 'Austria',
        type: 'Investment planning',
        service: 'It, Company',
        duration: '12 Years',
        add: 'Millington, Ave, TN 38053',
        architect: 'Don Johnson',
        share: 'It, Company',
        fax: ' 568 746 987'
    },



]
export default Projects;